<template>
    <div class="popup_box" v-if="pageShow">
        <div class="box_contetn">
            <p>请致电商家电话</p>
            <div class="text-center">
                <p>商家电话</p>
                <p style="margin-top: 12px;">18789889990</p>
            </div>
            <p class="cope_icon">
                <img src="../assets/icon/cope.png" alt="">
                <span>复制</span>
            </p>
            <el-button type="danger" @click="close">我知道了</el-button>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'kefu',
        data() {
            return {
                pageShow: false
            }
        },
        methods: {
            show() {
                this.pageShow = true
            },
            close() {
                this.pageShow = false
            }
        }
    }
</script>
<style lang="scss">
    .popup_box {
        width: 100vw;
        height: 100vh;
        position: fixed;
        left: 0;
        top: 0;
        /* background: rgba($color: #000000, $alpha: 0.2); */
        background: rgba(0, 0, 0, .2);

        .box_contetn {
            width: 320px;
            height: 306px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-around;
            background: #FFFFFF;
            border-radius: 16px;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }

        .cope_icon {
            width: 58px;
            height: 28px;
            color: #FD3B00;
            font-size: 14px;
            text-align: center;
            line-height: 28px;
            /* background: rgba($color: #FD3B00, $alpha: 0.1); */
            background: rgba(253, 59, 0, .1);
            border-radius: 4px;

            img {
                width: 14px;
                height: 14px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/kefu.vue